import CancelOutlined from '@mui/icons-material/CancelOutlined';
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';
import ErrorOutline from '@mui/icons-material/ErrorOutline';
import { useTheme } from '@mui/material';
import { AiToolCallState } from '@treadinc/horizon-api-spec';

import { terminalStatusColor } from '~tread-agent/confirmationCardStyles';
import { TreadAgentToolCallState } from '~tread-agent/types';

export default function TerminalStatusIcon({
  state,
}: {
  state: TreadAgentToolCallState;
}) {
  const theme = useTheme();
  const color = terminalStatusColor(state, theme);

  if (state === AiToolCallState.APPLIED) {
    return <CheckCircleOutline sx={{ color, fontSize: 16 }} />;
  }

  if (state === AiToolCallState.FAILED) {
    return <ErrorOutline sx={{ color, fontSize: 16 }} />;
  }

  return <CancelOutlined sx={{ color, fontSize: 16 }} />;
}
